import { IFullContent } from 'Entities/common'

export interface INews extends IFullContent {
  publishedDate: string
}

export type IEvents = INews

export enum StudyTypeEnum {
  PROGRAM_OF_GKS = 'PROGRAM_OF_GKS',
  ASSOCIATION_GKS = 'ASSOCIATION_GKS',
  NEWS_OF_STUDY = 'NEWS_OF_STUDY',
  PROGRAM_FOR_KOR = 'PROGRAM_FOR_KOR',
  PROGRAM_OF_VGKS = 'PROGRAM_OF_VGKS',
  EMPLOYMENT_OF_COMPANIES = 'EMPLOYMENT_OF_COMPANIES',
}

export interface IStudyInKorea extends Omit<INews, 'publishedDate'> {
  studyTypeEnum: StudyTypeEnum
}
